import CatalogCarousel from "../components/CatalogCarousel/CatalogCarousel";
import type { CatalogSlide } from "../components/CatalogCarousel/CatalogCarousel";
import "./Catalog.css";

import foxImg from "../img/fox.jpg";
import classicImg from "../img/classic.jpg";
import brazilianImg from "../img/brazilian.jpg";
import englishImg from "../img/english.jpg";
import megaImg from "../img/mega.jpg";
import brownImg from "../img/brown.jpg";
import egyptianImg from "../img/egyptian.jpg";

const WHATSAPP_NUMBER = "61422767519";

function Catalog() {
  const slides: CatalogSlide[] = [
    {
      id: "fox",
      title: "Fox Eye Lash Extensions",
      subtitle: "Cat Eye Effect",
      bullets: [
        "One-by-one eyelash extensions",
        "Enhances the eyes with no need for daily mascara or eyeliner",
        "Elegant, elongated cat-eye effect",
        "Lasts approximately 2 to 4 weeks (with infills)",
        "Lightweight and comfortable",
      ],
      price: "AUD 115.00",
      imageSrc: foxImg,
    },
    {
      id: "classic",
      title: "Classic Eyelash Extensions",
      subtitle: "One-by-One",
      bullets: [
        "Natural look with definition",
        "No need for daily mascara",
        "Lightweight and comfortable",
        "Lasts approximately 2 to 4 weeks (with infills)",
      ],
      price: "AUD 115.00",
      imageSrc: classicImg,
    },
    {
      id: "brazilian",
      title: "Brazilian Volume Lash Extensions",
      subtitle: "2D Volume",
      bullets: [
        "Natural look with definition",
        "No need for daily mascara",
        "Lightweight and comfortable",
        "Lasts approximately 2 to 4 weeks (with infills)",
      ],
      price: "AUD 100.00",
      imageSrc: brazilianImg,
    },
    {
      id: "english",
      title: "English Volume Lash Extensions",
      subtitle: "5D Volume",
      bullets: [
        "One-by-one eyelash extensions with high density (5D lashes)",
        "Elegant look with added volume",
        "Lasts approximately 2 to 4 weeks (with infills)",
        "Lightweight and comfortable",
      ],
      price: "AUD 100.00",
      imageSrc: englishImg,
    },
    {
      id: "mega",
      title: "Mega Authentic Lash Extensions",
      subtitle: "No Maintenance",
      bullets: [
        "High-density one-by-one eyelash extensions (3D capping technique)",
        "Bold, full-volume look",
        "Lasts approximately 4 to 7 weeks (no infills required)",
        "Lightweight and comfortable",
      ],
      price: "AUD 120.00",
      imageSrc: megaImg,
    },
    {
      id: "brown",
      title: "Brown Volume Lash Extensions",
      subtitle: "3D Volume",
      bullets: [
        "One-by-one eyelash extensions in brown/chestnut color",
        "Natural and subtle effect",
        "Lasts 2–4 weeks (with infills)",
        "Lightweight and comfortable",
      ],
      price: "AUD 100.00",
      imageSrc: brownImg,
    },
    {
      id: "egyptian",
      title: "Egyptian Volume Lash Extensions",
      subtitle: "3D Volume",
      bullets: [
        "One-by-one eyelash extensions with a full and sophisticated effect",
        "Perfect for those seeking definition with bold volume",
        "Lasts 2–4 weeks (with infills)",
        "Lightweight and comfortable",
      ],
      price: "AUD 100.00",
      imageSrc: egyptianImg,
    },
  ];

  function handleBook(slide: CatalogSlide) {
    const message = `Hi! I’m interested in the ${slide.title}.`;
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      message,
    )}`;

    window.open(url, "_blank");
  }

  return (
    <main className="catalogPage">
      <CatalogCarousel
        slides={slides}
        options={{ loop: false }}
        onBook={(id) => {
          const slide = slides.find((s) => s.id === id);
          if (slide) handleBook(slide);
        }}
      />
    </main>
  );
}

export default Catalog;
